<template>
  <v-app>
    <loading :active.sync="busy"/>

    <div id="wrap-lab" v-if="!busy">

      <div id="container-lab">
        <header-lab name="lab"></header-lab>

        <div id="content-lab">

          <div id="guide" v-if="!small_screen">

            <router-link tag="div" class="guide-tab" :class="{'guide-tab-color': route_name=='lab'}"
              :to="{name: 'lab'}">
              <v-icon :class="{'guide-tab-color': route_name=='lab'}">mdi-cube-outline</v-icon>
              <div class="guide-tab-text">{{ $t("lab.projects") }}</div>
            </router-link>

            <!-- <v-tooltip right>
              <template v-slot:activator="{ on }">
                <div class="guide-tab-inactive" v-on="on">
                  <v-icon>mdi-library</v-icon>
                  <div class="guide-tab-text">{{ $t("lab.library") }}</div>
                </div>
              </template>
              <span>{{ $t("lab.open_soon") }}</span>
            </v-tooltip> -->

            <router-link tag="div" class="guide-tab" :class="{'guide-tab-color': route_name=='watching-projects'}"
              :to="{name: 'watching-projects'}">
              <v-icon :class="{'guide-tab-color': route_name=='watching-projects'}">mdi-account-supervisor-circle</v-icon>
              <div class="guide-tab-text">{{ $t("lab.watching_projects") }}</div>
            </router-link>

            <div class="horizontal-line"></div>

            <div class="guide-subtitle">프리미엄</div>

            <router-link v-if="!expired"
              tag="div" class="guide-tab" :class="{'guide-tab-color': route_name=='document-clip'}"
              :to="{name: 'document-clip'}">
                <v-icon  :class="{'guide-tab-color': route_name=='document-clip'}">mdi-clipboard-outline</v-icon>
              <div class="guide-tab-text">{{ $t("lab.document_clip") }}</div>
            </router-link>
            <v-tooltip right v-else>
              <template v-slot:activator="{ on }">
                <div class="guide-tab-inactive" v-on="on">
                  <v-icon>mdi-clipboard-outline</v-icon>
                  <div class="guide-tab-text">{{ $t("lab.document_clip") }}</div>
                </div>
              </template>
              <span>프리미엄 기능입니다!</span>
            </v-tooltip>

            <router-link v-if="!expired"
              tag="div" class="guide-tab" :to="{name: 'reviews'}" :class="{'guide-tab-color': route_name=='reviews'}">
              <v-icon :class="{'guide-tab-color': route_name=='reviews'}">mdi-book-open-page-variant</v-icon>
              <div class="guide-tab-text">{{ $t("lab.my_reviews") }}</div>
            </router-link>
            <v-tooltip right v-else>
              <template v-slot:activator="{ on }">
                <div class="guide-tab-inactive" v-on="on">
                  <v-icon>mdi-book-open-page-variant</v-icon>
                  <div class="guide-tab-text">{{ $t("lab.my_reviews") }}</div>
                </div>
              </template>
              <span>프리미엄 기능입니다!</span>
            </v-tooltip>

            <!-- <div class="guide-tab-inactive">
              <v-icon>mdi-map-search</v-icon>
              <div class="guide-tab-text">트리 검색</div>
            </div>

            <div class="guide-tab-inactive">
              <v-icon>mdi-newspaper</v-icon>
              <div class="guide-tab-text">라운지</div>
            </div> -->

          </div>

          <div id="content-lab-inner" v-show="route_name=='lab'">
            <div v-if="small_screen&&!!(projects.length-1)" 
              id="content-document-clip">
              <v-card class="card" flat @click="$router.push({name: 'document-clip'})">
                <div class="card-title">도큐먼트 클립</div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn small fab dark color="#455ffe" v-on="on"
                      @click.stop="showAddDocuments()">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>도큐먼트 추가하기</span>
                </v-tooltip>
              </v-card>
            </div>
            <app-projects :ph="num_ph"></app-projects>
          </div>

          <div id="content-lab-inner" v-if="route_name=='watching-projects'">
            <app-watching-projects :ph="num_ph"></app-watching-projects>
          </div>

          <div id="content-lab-inner" v-if="route_name=='document-clip'">
            <app-document-clip></app-document-clip>
          </div>

          <div id="content-lab-inner" v-if="route_name=='reviews'">
            <app-reviews></app-reviews>
          </div>

        </div>
      </div>
    </div>

    <!-- TEMP: EVENT MODAL -->
    <template>
      <v-dialog v-model="event_2021_modal" width="400px">
        <v-card>
          <v-card-title class="card-title-wrapper">
            <span>비블리오트리즈 방문을 환영합니다!</span>
            <v-btn icon @click="event_2021_modal=false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            <div class="word-break">2021년 연말까지 <b class="explanation">'다시시작 이벤트'</b>를 진행합니다.</div>
            <div class="word-break">이벤트를 신청하고 <b class="explanation">한 달간 프리미엄 서비스를 무료로</b> 즐겨보세요!</div>
          </v-card-text>
          <v-card-text>
            <div class="word-break">프리미엄을 구독하지 않으셔도 베이직 회원으로 3개의 프로젝트를 마음껏 사용하실 수 있습니다.</div>
          </v-card-text>
          <v-card-text>
            <v-checkbox
              v-model="no_more_dialog"
              label="다시 보지 않기"
            ></v-checkbox>
          </v-card-text>
          <v-card-actions>
            <v-btn class="primary" @click="toSignup" depressed block>
              다시시작 이벤트 참여하기
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    
  </v-app>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import AppProjects from './Projects.vue'
import AppDocumentClip from './Document-clip.vue'
import AppReviews from './Reviews.vue'
import AppWatchingProjects from './Watching-projects.vue'

export default {
  metaInfo() {
    return {
      title: "Lab",
    }
  },

  components: {
    AppProjects,
    AppDocumentClip,
    AppReviews,
    AppWatchingProjects,
  },

  data() {
    return {
      busy: false,
      screen_width: window.innerWidth,
      event_2021_modal: false,
      no_more_dialog: false,
    }
  },

  computed: {
    ...mapGetters({
      projects: 'project/projects',
      expired: 'auth/is_expired',
    }),

    route_name() {
      return this.$route.name
    },

    small_screen() {
      return this.screen_width < 800
    },

    num_ph() {
      return Math.floor(this.screen_width / 252) - 1
    },
  },

  async created() {
    // TODO: error handling
    try {
      this.busy = true
      await this.$store.dispatch('project/getProjects')
      this.resize()
      window.addEventListener("resize", this.resize)
    } finally {
      this.busy = false
      let cookies_event_2021_modal = this.$cookies.get('event_2021_modal')
      if (cookies_event_2021_modal == '1') {
        this.event_2021_modal = false
      } else if (this.expired) {
        this.event_2021_modal = true
      }
    }
  },

  destroyed() {
    window.removeEventListener("resize", this.resize)
  },

  watch: {
    projects: {
      async handler(val) {
        let projs = JSON.parse(JSON.stringify(val))
        // Create document clip
        if(!projs.filter(v => v.mode == 9).length) {
          await this.createDocumentClip()
        }
      }
    },

    event_2021_modal(val) {
      if (!val&&this.no_more_dialog) {
        this.$cookies.set('event_2021_modal', 1, 60*60*24*120)
      }
    },
  },

  methods: {
    ...mapMutations({
      showAddDocumentsModal: 'modal/showAddDocuments',
      showExpiredModal: 'modal/showExpired',
    }),

    resize() {
      this.screen_width = window.innerWidth
    },

    async createDocumentClip() {
      await this.$store.dispatch('project/createProject', {
        title: "Document Clip",
        mode: 9,
      })
    },

    showAddDocuments() {
      if (this.expired) {
        this.showExpiredModal()
      } else {
        this.showAddDocumentsModal()
        this.$analytics.logEvent('click', { name: 'project_btn_openAddDocuments' })
      }
    },

    toSignup() {
      this.event_2021_dialog = false
      if (this.no_more_dialog) {
        this.$cookies.set('event_2021_modal', 1, 60*60*24*120)
      }
      this.$router.push({ name: 'signup' })
    },
  },

}
</script>

<style scoped>
  #wrap-lab {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: row;
    background-color: #ffffff;
  }

  /* Container */

  #container-lab {
    height: 100%;
    width: 100%;
  }

  #content-lab {
    width: 100%;
    display: grid;
    grid-template-columns: 70px auto;
  }

  #content-document-clip {
    padding: 20px 40px;
    background-color: rgb(249, 249, 249);
  }

  .card {
    padding: 20px;
    border-radius: 4px;
    background-color: rgba(83, 107, 255, 0.1);
    color: #455ffe;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .card-title {
    font-size: 14px;
    font-weight: 600;
  }

  #guide {
    height: calc(100vh - 60px);
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
  }

  .guide-tab, .guide-tab-inactive {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 14px;
    padding-bottom: 12px;
    cursor: pointer;
    font-size: 10px;
  }

  .guide-tab:hover {
    background-color: #fafafb;
  }

  .guide-tab-inactive {
    cursor: unset;
    color: #858d97;
  }

  .guide-tab-inactive i {
    color: #858d97;
  }

  .guide-tab-color {
    color: #ff5193 !important;
  }

  .guide-tab-text {
    margin-top: 8px;
  }

  #content-lab-inner {
    height: calc(100vh - 60px);
    width: 100%;
    background-color: rgb(249, 249, 249);
    overflow: auto;
  }

  .horizontal-line {
    border-top: 1px solid rgb(221, 221, 221);
    width: 70px;
    margin-top: 12px;
    margin-bottom: 12px;
  }

  .guide-subtitle {
    margin-bottom: 8px;
    color: #858d97;
  }

  .card-title-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }

  .explanation {
    color: #ff5193 !important;
  }

  @media only screen and (max-width: 800px) {
    #content-lab {
      display: flex;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/spa/lab/Layout.vue